import { ADD_COUPON, DELETE_COUPON, GET_COUPONS, UPDATE_COUPON } from "../types";

const initialState = { list: [], single: null };

const reducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case GET_COUPONS:
            return { ...state, list: payload };

        case ADD_COUPON:
            return {
                ...state,
                list: [payload, ...state.list],
            };

        case UPDATE_COUPON:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload._id ? payload : item
                ),
            };

        case DELETE_COUPON:
            return {
                ...state,
                list: state.list.filter((item) => item._id !== payload._id),
            };

        default:
            return state;
    }
};

export default reducer;
